// extracted by mini-css-extract-plugin
export default {"videosContentRoot":"VideosContent_videosContentRoot__aym-i","small":"VideosContent_small__mFPHo","video":"VideosContent_video__5XsMs"};